import React, { PropTypes, Component } from 'react'
import Dot from 'react-icons/lib/go/primitive-dot'
import cn from 'classnames'

class AssignedCourseItem extends Component {

  _selectItem = () => {
    const { item, onSelectItem } = this.props
    onSelectItem(item)
  }

  render() {
    const { item, k } = this.props

    return (
      <tr onTouchTap={this._selectItem}>
        <td>{k + 1}.</td>
        <td><span className={cn('dot', { 'active': item.get('is_active') })}><Dot /></span></td>
        <td><small>{item.get('course_code')}</small></td>
        <td>{item.get('course_name')}</td>
        <td><small>{item.get('college_code')}</small></td>
        <td>{item.getIn(['meta', 'chairman'])}</td>
      </tr>
    )
  }
}

AssignedCourseItem.propTypes = {
  item: PropTypes.object,
  k: PropTypes.number,
  onSelectItem: PropTypes.func,
}


export default AssignedCourseItem



// WEBPACK FOOTER //
// ./src/containers/Setup/Courses/assigned-course-item.js